<!-- Modal-Backdrop -->
<div
  class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50"
  (click)="close()"
  (document:keydown.escape)="close()"
>
  <!-- Modal-Box -->
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-5xl max-h-[85vh] flex flex-col m-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between gap-2 p-4 border-b border-base-300">
      <h3 class="text-lg font-bold">{{ heading }}</h3>
      <div class="flex items-center gap-2">
        <button
          class="bm-btn bm-btn-sm bm-btn-square bm-tooltip"
          data-tip="Filialen neu laden"
          type="button"
          (click)="refresh()"
        >
          <i class="fa fa-refresh"></i>
        </button>
        <!--
          Neue Filiale in einem neuen Tab anlegen, damit das Formular hinter dem
          Modal nicht verloren geht. Die aktive Projekt-Auswahl wird mitgegeben.
        -->
        <a
          class="bm-btn bm-btn-sm"
          routerLink="/filiale/neu"
          [queryParams]="createStoreQueryParams"
          target="_blank"
          rel="noopener"
        >
          <i class="fa fa-plus"></i>
          Filiale anlegen
        </a>
        <button class="bm-btn bm-btn-sm bm-btn-ghost bm-btn-square" (click)="close()">✕</button>
      </div>
    </div>

    <!-- Filter -->
    <div class="flex flex-col gap-2 p-4 border-b border-base-300">
      <input
        type="text"
        class="bm-input w-full"
        placeholder="Suchen nach Nr., Name, Firma oder Adresse…"
        [value]="searchTerm()"
        (input)="onSearchInput($event)"
      />

      @if (projectFilterEditable || unassignedFilterEditable) {
        <div class="flex flex-row flex-wrap items-center gap-3">
          @if (projectFilterEditable) {
            <ng-select
              class="flex-1 min-w-64"
              [items]="projects()"
              bindLabel="name"
              bindValue="id"
              [multiple]="true"
              placeholder="Alle Projekte"
              [ngModel]="selectedProjectIds()"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="selectedProjectIds.set($event); onFilterChanged()"
            />
          }

          @if (unassignedFilterEditable) {
            <label class="flex items-center gap-2 whitespace-nowrap">
              <input
                type="checkbox"
                class="bm-checkbox"
                [ngModel]="unassignedChecked()"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="unassignedChecked.set($event); onFilterChanged()"
              />
              Nur freie Filialen
            </label>
          }
        </div>
      }
    </div>

    <!--
      Grid im Server-Side Row Model: AG-Grid holt sich jede Seite selbst über die
      Datasource. paginationPageSize und cacheBlockSize müssen gleich sein, sonst
      passen Seitenwechsel und Abfrage nicht zusammen.
    -->
    <div class="flex-1 min-h-0 p-4">
      <ag-grid-angular
        class="h-[55vh] w-full"
        [theme]="hawkTheme"
        [localeText]="locale"
        [columnDefs]="colDefs"
        [defaultColDef]="defaultColDef"
        rowModelType="serverSide"
        [serverSideDatasource]="datasource"
        [pagination]="true"
        [paginationPageSize]="pageSize"
        [cacheBlockSize]="pageSize"
        rowSelection="single"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)"
      />
    </div>
  </div>
</div>
